/**
 * Фазы экрана «Распознавание» и переходы между ними.
 *
 * 🔴 MEETING — отдельная фаза, а не разновидность PROCESSING: бот уходит на
 * встречу часами, у неё свой текст, своя кнопка остановки и своё
 * восстановление после перезагрузки вкладки.
 *
 * Машина чистая, без React: экран рисуется по фазе, а решение о переходе
 * можно проверить тестом, не поднимая интерфейс.
 */
export const PHASES = {
  EMPTY: 'empty',
  UPLOADED: 'uploaded',
  MEETING: 'meeting',
  LIVE: 'live',
  PROCESSING: 'processing',
  DONE: 'done',
  // Пакет: несколько файлов разом. Своя фаза, а не вариант PROCESSING: у
  // пакета список файлов со своими состояниями, а не одна полоса прогресса.
  PACK: 'pack',
};

const TRANSITIONS = {
  [PHASES.EMPTY]: {
    file_picked: PHASES.UPLOADED,
    meeting_joined: PHASES.MEETING,
    live_started: PHASES.LIVE,
    // 🔴 У ссылки нет фазы «файл выбран»: настраивать нечего, скачивание
    // начинается сразу. Без этого перехода экран оставался пустым всё время
    // работы — задача шла, запись появлялась в Истории, а человек не видел
    // ни прогресса, ни результата.
    link_started: PHASES.PROCESSING,
    pack_picked: PHASES.PACK,
  },
  [PHASES.PACK]: { reset: PHASES.EMPTY },
  [PHASES.UPLOADED]: { started: PHASES.PROCESSING, reset: PHASES.EMPTY },
  [PHASES.MEETING]: { started: PHASES.PROCESSING, reset: PHASES.EMPTY },
  [PHASES.LIVE]: { started: PHASES.PROCESSING, reset: PHASES.EMPTY },
  // failed возвращает к настройкам, а не на пустой экран: файл всё ещё выбран,
  // и заставлять человека выбирать его заново после сбоя незачем.
  //
  // 🔴 failed_no_file — для ссылки. Фаза «готово к запуску» рисуется только при
  // выбранном файле, и общий failed оставлял человека с полоской ошибки над
  // пустотой: ни формы, ни ссылки, ни возможности повторить.
  [PHASES.PROCESSING]: {
    done: PHASES.DONE,
    failed: PHASES.UPLOADED,
    failed_no_file: PHASES.EMPTY,
    reset: PHASES.EMPTY,
  },
  [PHASES.DONE]: { reset: PHASES.EMPTY },
};

/** Новая фаза по событию; неизвестный переход не двигает экран. */
export function nextPhase(phase, event) {
  return (TRANSITIONS[phase] || {})[event] || phase;
}

/**
 * Нужно ли экрану сбросить себя по запросу приложения (удалена запись, которую он
 * показывает). Сбрасываем только застывший результат: на любой другой фазе идёт
 * чья-то работа (запись, загрузка, встреча), и удалённая запись к ней не относится.
 * Если у результата известен ключ задачи и он не совпал с удалённым — тоже не трогаем.
 */
export function shouldResetOnRequest(phase, resultTaskId, requestTaskId) {
  if (phase !== PHASES.DONE) return false;
  if (resultTaskId && requestTaskId && resultTaskId !== requestTaskId) return false;
  return true;
}
